import React, { Component } from "react";
import { Row, Col, Grid } from "react-bootstrap";
import { Helmet } from "react-helmet";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import Sidebar from "../../Sidebar/Sidebar";
import BannerRectangleLarge from "../../Banner/BannerRectangleLarge";

import "moment/locale/el";
import "moment/locale/it";

import { translate, getLanguage } from "../../Translation/Translation";
import { FETCH_URL } from "../../../utilities";

const styles = {
  paragraph: {
    lineHeight: "26px",
    color: "#293f54",
    fontSize: "16px",
  },
};

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
    };
  }

  componentDidMount() {
    return fetch(`${FETCH_URL}/proxy.php?ws=3624a2d36f2aa7035e6160b3997480d8`, {
      method: "POST",
      body: JSON.stringify({
        languageCode: getLanguage(),
        locationCode: null,
        eventTypeId: null,
        maxEventsSize: 6,
        date: null,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({ events: responseJson.events });

        return responseJson;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  render() {
    const { render } = this.props;
    return (
      <div>
        <Grid fluid className="no-padding">
          <Helmet>
            <title>Welcome to Openseas | Online Booking Engine</title>
            <meta
              name="description"
              content="Η Openseas σας ενημερώνει για τα δρομολόγια πλοίων για την  Ελλάδα, την Ιταλία, την Τουρκία, την Αλβανία και τα κυριότερα λιμάνια της Μεσογείου.  Διαθέσιμα δρομολόγια και πράκτορες. Κλείστε τώρα το επόμενο σας ταξίδι."
            />
          </Helmet>
          <Row style={{ margin: "0px" }}>
            <Col style={{ margin: "0px" }}>
              <Header fullpage data={this.props} />
            </Col>
          </Row>
          <Row style={{ margin: "0px" }}>
            <div className="OSPageContainer">
              <div className="OSPageContent ">
                <p style={{ ...styles.paragraph, ...{ padding: "20px 0px" } }}>
                  {translate(
                    getLanguage(),
                    "Your online travel guide to the Mediterranean ferry routes. All ferry routes in Greece, the surrounding countries (Italy, Turkey, Albania) and the major routes in the Mediterranean."
                  )}
                  {translate(
                    getLanguage(),
                    "The most up-to-date information on ferry routes, is at your entire disposal, through the LIKNOSS’ and the Ferry Companies’ reservation systems."
                  )}
                </p>
                <p
                  style={{
                    ...styles.paragraph,
                    ...{ padding: "0 0 20px 0px" },
                  }}
                >
                  {translate(
                    getLanguage(),
                    "This is an informative site, but allows you to redirect to the online booking engines of the Ferry Companies and of the Travel Agencies, after you have selected the desirable ferry route."
                  )}
                  {translate(
                    getLanguage(),
                    'For ticket issuance or for additional information, you may choose from the "Travel Agencies" section, the agency of your choice.'
                  )}
                </p>
                {render(this.state)}
                <Row
                  className="BannerRectangleLarge"
                  style={{ margin: "40px 0 20px 0", textAlign: "center" }}
                >
                  <BannerRectangleLarge osDest="ALL" />
                </Row>
              </div>
              <div className="OSPageSidebar">
                <Sidebar />
              </div>
            </div>
          </Row>
          <Row style={{ margin: "0px" }}>
            <Footer />
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Pages/Home/Home.js